<template>
  <el-card shadow="never"
           class="aui-card--fill">
  <div class="box-card" :style="{'height': cardHeight+'px'}">
    <el-row :gutter="20">
      <el-col :span="12">
    <el-card :style="{'height': cardHeight+'px'}">
        <el-form :model="querydataForm"
               :label-position="labelPosition"
               ref="inServForm"
               size="small"
               >
      <el-row :gutter="20">
        <el-form-item label="  ">
          <el-input v-model="querydataForm.regionCode"></el-input>
          <el-button type="primary"
                     @click="addParent">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-row>
      <el-row>
         <el-col :span="24">
    <el-button size="small"
               type="text"
                 @click="defaulteopen">展开所有</el-button>
      <el-button size="small"
                 type="text"
                 @click="defaulteend">收起所有</el-button>
           <span>显示:</span>
             <el-checkbox @change="addParent" label="10" v-model="querydataForm.statusChecked"
                         name="10">活动</el-checkbox>
            <el-checkbox @change="addParent" label="20" v-model="querydataForm.checked"
                         name="20">不活动</el-checkbox>
         </el-col>
         </el-row>
      </el-form>
     <div id="scrolldIV2" :style="{'max-height': (cardHeight-150)+'px'}"
     style="overflow:auto;overflow-x:hidden;">
    <el-tree :data="data"
             :props="defaultProps"
             @node-click="handleNodeClick"
             :default-expand-all="zhanDisabled"
             node-key="catalogId"
             ref="selectTree">
      <span class="custom-tree-node"
            slot-scope="{ node, data }">
            <span :title="node.label" class="cataglog-tree-li">{{ node.label }}</span>
        <span>
          <em class="el-icon-plus ipl"
             v-if="(data.parentCatalogId == '0'|| (data.parentCatalogId == '1' && data.catalogStatus=='10')) && $hasPermission('learning:coursecatalog:save')"
             @click.stop="add(data,node.label,node)"></em>
          <em class="el-icon-edit ipl" v-if="$hasPermission('learning:coursecatalog:save')"
             @click.stop="update(data,node.label)"></em>
          <!-- 删除课程分类 -->
          <em class="el-icon-delete ipl" v-if="data.parentCatalogId !== 0  && $hasPermission('learning:coursecatalog:delete')"
             @click.stop="isdelete(data)"></em>
        </span>
      </span>
    </el-tree>
     </div>
    </el-card>
      </el-col>
      <!-- 右侧tab -->
       <el-col :span="10">
      <el-card :style="{'height': cardHeight+'px'}"
                   ref="resourceRef">
        <!-- 查看和编辑的tab -->
        <el-form label-width="100px"
             v-show="allform"
             :model="dataForm"
             ref="dataForm"
             :rules="dataRuleAll"
             >
          <el-form-item :label="$t('catalog.catalogstatus')" prop="catalogStatus" style="width:200px;">
            <el-select size="small"
                       v-model="dataForm.catalogStatus"
                       filterable
                       :disabled="isDisabled">
              <el-option v-for="(item,index) in cataglogType"
                         :key="'catlog'+index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('catalog.catalognamecn')"  prop="catalogNameCn">
            <el-input size="small" style="width:200px;"
                      v-model="dataForm.catalogNameCn"
                      :disabled="isDisabled"></el-input>
          </el-form-item>
          <el-form-item :label="$t('catalog.courseLevel')"  prop="coursePriority" v-if="dataForm.parentCatalogId!==1">
            <el-select size="small"
                      v-model="dataForm.coursePriority"
                      filterable
                      :disabled="isDisabled">
              <el-option v-for="(item,index) in courseLevelList"
                        :key="'level'+index"
                        :label="item.name"
                        :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <div style="margin: 10px 0px 20px 230px;"
                v-show="updateshow">
              <el-button type="primary"
                      @click="updateSave">{{ $t('region.save') }}</el-button>
            </div>
          </el-row>
        </el-form>
        <!-- 新增 -->
        <el-form
             label-width="100px"
             :model="adddataForm"
             :rules="dataRuleAdd"
             ref="adddataForm"
             v-show="saveform">
          <el-form-item :label="$t('catalog.catalogstatus')" prop="catalogStatus">
            <el-select  size="small"
                       v-model="adddataForm.catalogStatus"
                       filterable
                       :disabled="isDisabled">
              <el-option v-for="(item,index) in cataglogType"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-form-item :label="$t('catalog.catalognamecn')" prop="catalogNameCn">
              <el-input size="small" style="width:200px;"
                        v-model="adddataForm.catalogNameCn"
                        :disabled="isDisabled"></el-input>
            </el-form-item>
            <el-form-item :label="$t('catalog.courseLevel')"  prop="coursePriority" v-if="adddataForm.parentCatalogId!==1">
            <el-select size="small"
                      v-model="adddataForm.coursePriority"
                      filterable>
              <el-option v-for="(item,index) in courseLevelList"
                        :key="'courseLevel'+index"
                        :label="item.name"
                        :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
         <el-col :span="8">
          <div style="margin: 10px 0px 20px 230px;"
              v-show="saveshow">
            <el-button type="primary" v-if="$hasPermission('learning:coursecatalog:save')"
                      @click="addsave">{{ $t('region.save') }}</el-button>
          </div>
         </el-col>
        </el-row>
        </el-form>
      </el-card>
      </el-col>
    </el-row>
  </div>
  </el-card>
</template>

<script type="text/javascript">
import { treeDataTranslate } from '@/utils'

export default {
  data () {
    let _this = this
    return {
      typs: '10',
      labelPosition: 'left',
      visible: false,
      data: [],
      datatmp: [],
      idArr: [],
      defaultProps: {
        children: 'children',
        label: 'catalogNameCn',
        id: 'catalogId'
      },
      regionGrade: _this.enums['region_grade'],
      cataglogType: _this.enums['cataglogType'],
      oreginId: '',
      dataForm: {
        // checked1: true
      },
      querydataForm: { type: '10',
        statusChecked: true,
        checked: false
      },
      adddataForm: {},
      isDisabled: true,
      updateshow: false,
      saveshow: false,
      saveform: false,
      allform: false,
      zhanDisabled: true,
      cardHeight: undefined,
      courseLevelList: this.enums['coursePriority'],
      dataRuleAll: {
        catalogStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        catalogNameCn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 40, message: this.$t('validate.validateLength', { 'handle': '40' }), trigger: 'blur' }
        ],
        coursePriority: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
        ]
      },
      dataRuleAdd: {
        catalogStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        catalogNameCn: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 50, message: this.$t('validate.validateLength', { 'handle': '50' }), trigger: 'blur' }
        ],
        coursePriority: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
        ]
      }
    }
  },
  mounted () {
    this.cardHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
    this.addParent()
  },
  methods: {
    addParent () {
      let typs = '10'
      if ((this.querydataForm.statusChecked === this.querydataForm.checked) && (this.querydataForm.statusChecked === false)) {
        this.statusChecked = true
      }
      if (this.querydataForm.statusChecked && this.querydataForm.checked) {
        typs = ''
      } else if (!this.querydataForm.statusChecked && !this.querydataForm.checked) {
        typs = ''
      } else {
        if (this.querydataForm.statusChecked) {
          typs = '10'
        } else {
          typs = '20'
        }
      }
      this.typs = typs
      this.getLogList({ regionCode: this.querydataForm.regionCode, type: typs })
    },
    // 全部展开
    defaulteopen () {
      for (let i = 0; i < this.$refs.selectTree.store._getAllNodes().length; i++) {
        this.$refs.selectTree.store._getAllNodes()[i].expanded = true
      }
    },
    // 全部折叠
    defaulteend () {
      for (let i = 1; i < this.$refs.selectTree.store._getAllNodes().length; i++) {
        this.$refs.selectTree.store._getAllNodes()[i].expanded = false
      }
    },
    // 获取树列表
    getLogList (params) {
       this.$request.get('/learning/coursecatalog/list', params
      ).then((res) => {
        this.data = treeDataTranslate(res, 'catalogId', 'parentCatalogId')
      }).catch(() => { })
    },
    // 获取详情
    getDetail (catalogId) {
      this.$request.get(`/learning/coursecatalog/info/${catalogId}`).then((res) => {
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
        this.adddataForm.parentCatalogId = this.dataForm.catalogId
      }).catch(() => { })
    },
    // 点击获取每个treelist值的详细信息
    handleNodeClick (data) {
      this.allform = true
      this.isDisabled = true
      this.saveform = false
      this.saveshow = false
      this.updateshow = false
      this.oreginId = data.catalogId
      this.getDetail(data.catalogId)
    },
    // 修改后保存
    updateSave () {
      this.$set(this.dataForm, 'coursePriority', this.dataForm.coursePriority)
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('course.save') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          this.dataForm.catalogNameCn = this.dataForm.catalogNameCn.trim()
          let { catalogId, catalogStatus, catalogNameCn, parentCatalogId, coursePriority} = this.dataForm
          this.$request.post(`/learning/coursecatalog/update`,
            {
              catalogId,
              catalogNameCn,
              catalogStatus,
              parentCatalogId,
              coursePriority
            }
          ).then((res, _total, code, msg, _data) => {
            console.log(res)
            if (code === 2) {
              this.$message({
                showClose: true,
                message: msg.msg,
                type: 'error',
                duration: 3000
              })
            } else {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.saveform = false
                  this.allform = true
                  this.isDisabled = true
                  this.updateshow = false
                  this.saveshow = false
                  this.getLogList({ regionCode: this.querydataForm.regionCode, type: this.typs })
                }
              })
            }
          }).catch(() => { })
        })
      }).catch(() => { })
    },
    update (data) {
      this.adddataForm = {}
      this.isDisabled = false
      this.saveform = false
      this.allform = true
      this.updateshow = true
      this.saveshow = false
      let allid = data.catalogId
      this.getDetail(allid)
      this.$refs['dataForm'].resetFields()
    },
    add (data, label, node) {
      this.isDisabled = false
      this.adddataForm = {}
      this.allform = false
      this.saveform = true
      this.saveshow = true
      this.updateshow = false
      this.adddataForm.parentCatalogId = data.catalogId
      this.adddataForm.parentName = label
      this.$set(this.adddataForm,'coursePriority', '')
      this.dataForm.parentCatalogId = data.catalogId
      if (node.level === 1) {
        this.adddataForm.regionGrade = '2'
      }
      if (node.level === 2) {
        this.adddataForm.regionGrade = '3'
      }
      if (node.level === 3) {
        this.adddataForm.regionGrade = '4'
      }
      this.$refs['adddataForm'].resetFields()
    },
    // 新增后保存
    addsave () {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('course.save') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.adddataForm.parentName = this.dataForm.parentName
        this.$refs['adddataForm'].validate((valid) => {
          if (this.dataForm.catalogNameCn === '') {
            return false
          }
          if (!valid) {
            return false
          }
          this.adddataForm.catalogNameCn = this.adddataForm.catalogNameCn.trim()
          this.$request.post(`/learning/coursecatalog/save/`,
            this.adddataForm
          ).then((_res, _total, code, msg) => {
            if (code === 2) {
              this.$message({
                showClose: true,
                message: msg.msg,
                type: 'error',
                duration: 3000
              })
            } else {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.dataForm.catalogNameCn = this.adddataForm.catalogNameCn
                  this.dataForm.catalogStatus = this.adddataForm.catalogStatus
                  this.$set(this.dataForm, 'coursePriority', this.adddataForm.coursePriority)
                  this.saveform = false
                  this.allform = true
                  this.isDisabled = true
                  this.updateshow = false
                  this.saveshow = false
                  this.getLogList({ regionCode: this.querydataForm.regionCode, type: this.typs })
                }
              })
            }
          }).catch(() => { })
        })
      }).catch(() => { })
    },
    // 删除每个子节点
    isdelete (data) {
      this.dataForm = data
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.$request.post(`/learning/coursecatalog/delete`,
          this.dataForm
        ).then((_res, _total, code, msg, _data) => {
          if (code === 2) {
            this.$message({
              showClose: true,
              message: msg.msg,
              type: 'error',
              duration: 3000
            })
          } else {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500
            })
            this.getLogList({ regionCode: this.querydataForm.regionCode, type: this.typs })
            this.dataForm = {}
            this.adddataForm = {}
            this.saveform = false
            this.allform = false
            this.isDisabled = true
            this.updateshow = false
            this.saveshow = false
          }
        }).catch(() => { })
      }).catch(() => { })
    }
  }
}
</script>
<style>
.el-form--label-top .el-form-item__label {
    /* float: none; */
    display: inline-block;
    text-align: left;
    padding: 0 0 10px;
}
.el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: relative;
    top: 100%;
    left: 0;
}
</style>
<style lang='scss' scoped>
.cataglog-tree-li{
  max-width: 16em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.el-form-item__error {
    text-overflow: ellipsis;
    white-space: nowrap;
}
.grid-content {
    border-radius: 4px;
  }

.divcss {
  width: 60%;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.ipl {
  margin-left: 15px;
  padding: 2px;
  border: 1px #ffffff solid;
}
.ipl:hover {
  background-color: #fff;
  color: #1c69d3;
  border: 1px #1c69d3 solid;
}
.el-input {
  max-width: 260px !important;
}
.el-select {
  width: 200px !important;
}

/*大卡片的样式*/
.box-card1 {
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;

  border-radius: 4px;
  overflow: hidden;
  padding: 0 0 0 0;
}
</style>